import { render, staticRenderFns } from "./system_serve_list.vue?vue&type=template&id=96bb5ac0&"
import script from "./system_serve_list.vue?vue&type=script&lang=js&"
export * from "./system_serve_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports